// extracted by mini-css-extract-plugin
export var gridWrapperStyle = "feature_grid-module--gridWrapperStyle--C8nvY";
export var headingWrapperStyle = "feature_grid-module--headingWrapperStyle--Dq3i8";